<div *ngIf="pkg$$ | async as pkg" class="page">
  <store-header-container
    [iconUrl]="pkg.icon"
    [title]="pkg.name"
    [tagline]="pkg.tagline"
    [prerequisite]="productNameForSingleAddon$ | async"
    [chipLabels]="lmiCategories$ | async"
    [appPrice]="appPrice"
    [showAction]="showActionButton"
    [showPricing]="showPricing"
    [actionLabel]="actionLabel | translate"
    [actionEnabled]="this.enableAddToCart"
    [hideTags]="this.hideTags"
    (actionSelected)="emitGetItNow()"
    (contactActionClick)="handleContactActionClick()"
  ></store-header-container>

  <ng-container *ngIf="pkg?.content">
    <section class="white-background package-description">
      <store-selling-info [description]="pkg.content"></store-selling-info>
    </section>
  </ng-container>

  <store-products-nav-v2
    [items]="orderedLineItems$ | async"
    [hideItemsNav]="pkg?.hide_product_icons_and_names"
    (itemSelected)="selectItem($event)"
  ></store-products-nav-v2>

  <ng-container *ngIf="selectedItem$ | async as selectedItem">
    <div *ngIf="!pkg?.hide_product_details" class="package-content">
      <div class="left-column">
        <section
          *ngIf="selectedItem?.item?.description || selectedItem?.item?.keySellingPoints"
          class="white-background product-description"
        >
          <store-selling-info
            [description]="selectedItem?.item?.description"
            [keySellingPoints]="selectedItem?.item?.keySellingPoints"
          ></store-selling-info>
        </section>

        <section *ngIf="selectedItem?.item?.faqs?.length > 0 && selectedItem?.item?.faqs[0].question">
          <h2 class="va-component-title">
            {{ 'FRONTEND.STORE.FAQS' | translate }}
          </h2>
          <store-faqs [faqs]="selectedItem.item.faqs"></store-faqs>
        </section>
      </div>

      <div class="right-column">
        <section *ngIf="selectedItem?.item?.screenshotUrls?.length > 0">
          <h2 class="va-component-title">
            {{ 'FRONTEND.STORE.GALLERY' | translate }}
          </h2>
          <va-image-gallery [imageUrls]="selectedItem.item.screenshotUrls"></va-image-gallery>
        </section>

        <section *ngIf="selectedItem?.item?.files?.length > 0">
          <h2 class="va-component-title">
            {{ 'FRONTEND.STORE.FILES' | translate }}
          </h2>
          <store-files [files]="selectedItem.item.files"></store-files>
        </section>
      </div>
    </div>
  </ng-container>
</div>
